import ErrorFallback from 'Components/ErrorFallback'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'
import { WalttiPosDeviceDetailPage, WalttiPosDeviceListPage } from './Pages'

const WalttiPosRemoteConfigRoot = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<WalttiPosDeviceListPage />} />
        <Route path={`create/:type`} element={<WalttiPosDeviceDetailPage />} />
        <Route path={`:id/:type`} element={<WalttiPosDeviceDetailPage />} />
      </Routes>
    </ErrorBoundary>
  )
}
export default WalttiPosRemoteConfigRoot
